import { Dashboard } from "@/model/data/dashboard/Dashboard";
import { ApiGenericResponse } from "../../ApiGenericResponse";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../../Command";

const ENDPOINT = "/dashboard/";

export class UpdateDashboardCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "put";

    dashboard: Dashboard;

    constructor(dashboard: Dashboard) {
        super();
        this.endPoint += dashboard.id;
        this.dashboard = dashboard;
    }

    public async execute(): Promise<ApiGenericResponse> {
        var res = await this.executeCommand(this.dashboard);
        return new ApiGenericResponse(res);
    }
}
